import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useOutsideClick } from '../hooks/useOutsideClick';

interface SliderProps {
  children: React.ReactNode;
  defaultHeight?: number;
  isDimmed?: boolean;
  onClickOutSide?: () => void;
}

const Slider = ({
  children,
  defaultHeight = 256,
  isDimmed,
  onClickOutSide,
}: SliderProps) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false); // Slider의 확장 상태를 관리하기 위한 상태 변수

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useOutsideClick({ ref: sliderRef, handler: onClickOutSide });

  // Slider를 클릭할 때 실행될 함수
  const toggleExpand = () => setIsExpanded(!isExpanded);

  let startY = 0; // 터치 시작 Y 좌표

  // 터치 시작
  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    startY = e.touches[0].clientY; // 터치 시작 지점의 Y 좌표 저장
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {};

  // 터치 종료
  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    const endY = e.changedTouches[0].clientY; // 터치 종료 지점의 Y 좌표
    const diffY = startY - endY; // Y 좌표의 변화량 계산

    // 쓸어올리기 동작 감지
    if (diffY > 30) {
      // 쓸어올리기 동작의 임계값을 30px로 설정
      setIsExpanded(true); // Slider 확장
    } else if (diffY < -30) {
      // 쓸어내리기 동작의 임계값을 -30px로 설정
      setIsExpanded(false); // Slider 축소
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: 200,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'fixed',
          top: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }}
      ></div>
      <div
        ref={sliderRef}
        style={{
          position: 'fixed',
          display: 'flex',
          flexDirection: 'column',
          bottom: 0,
          width: '100%',
          height: isExpanded ? `calc(100% - 62px)` : `calc(${defaultHeight}px)`,
          backgroundColor: '#272A37',
          borderTopLeftRadius: '30px',
          borderTopRightRadius: '30px',
          transform: 'translateY(0%)',
          transition: 'height 0.5s ease-in-out', // 높이 변경에 대한 전환 효과 추가
          boxShadow: '0 -10px 8px 0 rgba(0, 0, 0, 0.16)',
        }}
      >
        <div
          style={{ width: '100%' }}
          onClick={toggleExpand}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            style={{
              width: 34,
              height: 6,
              backgroundColor: '#4c526b',
              borderRadius: 3,
              margin: '10px auto 20px',
            }}
          ></div>
        </div>
        {isDimmed && <Dimmed />}
        <div
          style={{
            width: '100%',
            flex: 1,
            padding: '0 20px 30px 20px',
            overflow: 'hidden',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Slider;

const Dimmed = styled.div`
  width: 100%;
  height: calc(100% - 38px);
  position: absolute;
  bottom: 0;
  background-color: #272a37;
  background: linear-gradient(
    180deg,
    rgba(39, 42, 55, 0.1) 40%,
    rgba(39, 42, 55, 0.8) 100%
  );
`;
